import { ETypeEtapeBonTravail } from 'src/app/entites/enums/type-etape-bon-travail';
import { EtapeBonTravailEntite } from 'src/app/entites/mecanique/etape-bon-travail';

/**
 * Whether the étape is an entretien préventif (linked EP or type EP).
 */
export function estEtapeEntretienPreventif(etape: EtapeBonTravailEntite | null | undefined): boolean {
    return !!etape?.entretienPreventif
        || etape?.typeEtapeBonTravail?.typeEtapeBonTravailId === ETypeEtapeBonTravail.EntretienPreventif;
}

/**
 * Whether the patched field is Description or Catégorie on the étape.
 */
export function estChampDescriptionOuCategorieEtape(champ: string | null | undefined): boolean {
    const nom = (champ ?? '').toLowerCase();
    return nom === 'description' || nom === 'categorie' || nom === 'categorieentretienid';
}
